<template>
  <div class="sygni-grid">
    <div class="row mb-4">
      <div class="col-12">
        <b-form-group>
          <b-textarea v-model="note.content" v-bind:class="{ 'is-invalid': emptyNote }"></b-textarea>
          <b-form-invalid-feedback>{{ errors.note.content }}</b-form-invalid-feedback>
        </b-form-group>
        <button class="btn btn-success float-right mt-1" :disabled="processingNote" @click="addNote()">{{ $t('btn.add_note') }}</button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <grid-pagination :total-count="totalCount"
                         :per-page="perPage"
                         :current-page="currentPage"
                         @load-items="paginationReload"></grid-pagination>
        <div class="table-responsive">
          <b-table
              striped show-empty
              :empty-text="$t('table.no_results')"
              :busy="isBusy"
              hover
              head-variant="dark"
              outlined
              :sort-by.sync="orderColumn"
              :sort-desc.sync="orderDirection"
              :no-local-sorting="true"
              :items="items"
              :fields="fields"
          >
            <template v-slot:cell(actions)="data">
              <button class="btn btn-xs btn-danger" @click="removeNote(data.item.id)">{{$t('table.btn.delete')}}</button>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{$t('state.loading')}}</strong>
              </div>
            </template>
          </b-table>
        </div>

        <grid-pagination :total-count="totalCount"
                         :per-page="perPage"
                         :current-page="currentPage"
                         @load-items="paginationReload"></grid-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import alertify from 'alertifyjs';
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
import GridMixin from "../../components/grid/GridMixin";

export default {
  mixins: [GridMixin],
  components: {
    GridPagination
  },
  props: ['objectId'],
  data() {
    return {
      gridGetUrl: `/api/crm/note?objectId=${this.$route.params.id}`,
      showDeleted: false,
      orderColumn: 'createdAt',
      orderDirection: false,
      isBusy: false,
      note: {
        objectId: this.$route.params.id,
        content: ''
      },
      fields: [
        {key: 'content', label: this.$t('table.header.note_content'), class: 'note-content', sortable: false},
        {key: 'createdAt', label: this.$t('table.header.note_date'), sortable: true},
        {key: 'author', label: this.$t('table.header.author'), sortable: false},
        {key: 'actions', label: this.$t('table.header.actions'), sortable: false}
      ],
      errors: {
        note: {
          content: 'Content cannot be left blank!'
        }
      },
      processingNote: false,
      emptyNote: false,
      items: [],
      totalCount: 0,
      perPage: 10,
      currentPage: 1,
      totalPages: 1
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    removeNote(id) {
      let _that = this;
      this.$bvModal.msgBoxConfirm(this.$t('label.note.are_you_sure').toString())
          .then(function (resp) {
            if (resp === true) {
              axios.delete('/api/crm/note/' + id)
                  .then(function () {
                    alertify.success(this.$t('label.note.removed_success'))
                    _that.loadItems();
                  })
                  .catch(function (error) {
                    console.log(error);
                  })
            }
          })
    },
    addNote() {
      if (this.note.content.length) {
        this.processingNote = true;
        let _that = this;
        axios.post('/api/crm/note', this.note)
            .then(function () {
              alertify.success(this.$t('label.note.add_success'))
              _that.note.content = '';
              _that.emptyNote = false;
              _that.loadItems();
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              _that.processingNote = false;
            })
      } else {
        this.emptyNote = true;
      }
    },
    paginationReload(data) {
      this.currentPage = data.currentPage;
      this.perPage = data.perPage;
      this.loadItems();
    },
    loadItems(defaultFilters) {
      this.isBusy = true;
      let _that = this;
      let offset = this.perPage * (this.currentPage - 1);
      let fullUrl = this.gridGetUrl + '&limit='
          + this.perPage
          + '&offset=' + offset
          + this.createSortQuery() + this.createFilterQuery();
      if(defaultFilters && typeof defaultFilters === 'string') {
        fullUrl = fullUrl + defaultFilters;
      }

      axios.get(fullUrl)
          .then(function (response) {
            _that.items = response.data.items;
            _that.totalCount = response.data.totalCount;
            _that.isBusy = false;
          })
          .catch(error => {
            console.log(error);
          });
    }
  }
}
</script>
